/** Max items in `users.{uid}.rewardsToRedeem` (YOUR REWARDS tiles from Firestore). */
export const MAX_USER_REWARD_TILES = 7;

export const REWARD_TILE_LIMIT_MESSAGE =
  "You've reached your maximum number of rewards. Use your existing rewards before saving new ones.";

export function rewardTileCountAtOrOverLimit(rewardsToRedeem) {
  const n = Array.isArray(rewardsToRedeem) ? rewardsToRedeem.length : 0;
  return n >= MAX_USER_REWARD_TILES;
}
